export enum WindOnshoreSubTechnology {
  GROUND_BASED = 'GROUND_BASED',
}
export const windSubTechnologyToLabel = {
  [WindOnshoreSubTechnology.GROUND_BASED]: 'Ground Based',
};
